var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58043 8.57998C4.38043 8.57998 4.19043 8.49998 4.05043 8.35998L0.22043 4.52998C-0.0695703 4.23998 -0.0695703 3.75998 0.22043 3.46998C0.51043 3.17998 0.99043 3.17998 1.28043 3.46998L4.58043 6.76998L10.7204 0.629976C11.0104 0.339976 11.4904 0.339976 11.7804 0.629976C12.0704 0.919976 12.0704 1.39998 11.7804 1.68998L5.11043 8.35998C4.97043 8.49998 4.78043 8.57998 4.58043 8.57998Z",
    fill: "#01C860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.a32acb9749196ef4fad500d2a68441c0.svg";
export { ForwardRef as ReactComponent };